import styled from 'styled-components/macro';

import {useState} from "react";
import {useHistory} from "react-router-dom";
import {
    Button,
    FormControl,
    FormLabel,
    Input,
    Modal,
    ModalBody,
    ModalCloseButton,
    ModalContent,
    ModalFooter,
    ModalHeader,
    ModalOverlay,
} from "@chakra-ui/react";
import {useCreatePost} from "../api/submit";
import {useFeedback} from "../store/feedback";
import TextField from "./text_field";
import {themecolors} from "../utils/themecolors";

const Item = styled.div``;
const Save = styled.div``;

const CrossPost = styled(({className, originalPost, onClose}) => {

    const history = useHistory();
    const {error, feedbackCh} = useFeedback();

    const [post, setPost] = useState({
        type: 'link',
        community: '',
        title: originalPost.title,
        link: `https://scored.co/c/${originalPost.community}/p/${originalPost.uuid}/`,
    });
    const set = (name) => (value) => setPost((post) => ({...post, [name]: value}));
    const [posting, setPosting] = useState(false);

    const createPost = useCreatePost(feedbackCh);
    const handleSave = async () => {
        if (posting) return;
        try {
            setPosting(true);
            const {link} = await createPost(post);
            onClose();
            history.replace(link);
        } catch {
            // error is displayed
        }
        setPosting(false);
    };

    return (
        <Modal
            isOpen
            onClose={onClose}
        >
            <ModalOverlay />
            <ModalContent>
                <ModalHeader>Share to another community</ModalHeader>
                <ModalCloseButton />
                    <ModalBody pb={6}>
                        <FormControl>
                            <FormLabel>Community</FormLabel>
                            <Input value={post.community} onChange={(e) => set('community')(e.currentTarget.value)}
                                   placeholder="Cats" />
                        </FormControl>
                    </ModalBody>
                <ModalFooter>
                    <Button variant="cancel" mr={3} onClick={onClose}>Cancel</Button>
                    <Button variant="blue" onClick={handleSave} isLoading={posting}>
                        Post
                    </Button>
                </ModalFooter>
            </ModalContent>
        </Modal>
    )})`
  ${TextField} {
    margin-bottom: 16px;
  }
  ${Save} {
    margin-top: auto;
    background-color: rgb(56, 98, 250);
    text-align: center;
    padding: 12px;
    border-radius: 6px;
    cursor: pointer;
    font-weight: 500;
    color: ${({theme}) => themecolors.pure_white};
  }
  ${Item} {
    margin-top: 12px;
  }
  ${Item} svg {
    margin-right: 16px;
    font-size: 26px;
  }
  ${Item} span {
    cursor: pointer;
  }
`;

export default CrossPost;
